import { render } from "./stage1Review.vue?vue&type=template&id=5869916a&scoped=true"
import script from "./stage1Review.vue?vue&type=script&lang=js"
export * from "./stage1Review.vue?vue&type=script&lang=js"

import "./stage1Review.vue?vue&type=style&index=0&id=5869916a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5869916a"]])

export default __exports__